import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from './views/error/error.component';
import { AuthGuardService } from './core/guards/auth-guard.guard';
import { SigninloadingComponent } from './views/public-view/signinloading/signinloading.component';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./views/public-view/public-view.module').then(m => m.PublicViewModule)
  },
  {
    path: 'user',
    loadChildren: () => import('./views/admin-view/admin-view.module').then(m => m.AdminViewModule),
    canActivate: [AuthGuardService]
  },
  {
    path:'signin-load',
    component:SigninloadingComponent
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '**',
    component: ErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
